import { Box, TextButton } from '@modusign/design-system';

interface SignerCardsDeleteEmptySignersButtonProps {
  onClick: () => void;
}
export default function SignerCardsDeleteEmptySignersButton({
  onClick,
}: SignerCardsDeleteEmptySignersButtonProps) {
  return (
    <Box mb={4} py={3} textAlign="center">
      <TextButton fontWeight="medium" onClick={onClick}>
        빈 서명자 카드 모두 삭제
      </TextButton>
    </Box>
  );
}
